import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import BankAccountCreateViewModel from "viewModels/finance/bankAccounts/bankAccountCreateViewModel";
import CreateView from "../../common/create";
import BankAccountForm from "./bankAccountForm";

const BankAccountCreateView: ViewComponent<BankAccountCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<BankAccountForm vm={vm} />} />
));

registerView(BankAccountCreateView, BankAccountCreateViewModel);
